import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateNotesOfGoalRequest: ["id", "notes"],
  updateNotesOfGoalSuccess: ["goal"],
  updateNotesOfGoalFailure: null,
});

export const UpdateNotesOfGoalTypes = Types;
export const UpdateNotesOfGoalActions = Creators;
export default Creators;

export const INITIAL_STATE = Immutable({
  id: null,
  notes: null,
  goal: null,
  fetching: null,
  success: null,
  error: null,
});

export const UpdateNotesOfGoalSelectors = {
  getData: (state: any) => state.updateNotesOfGoal.data,
  isFetching: (state: any) => state.updateNotesOfGoal.fetching,
  isSuccess: (state: any) => state.updateNotesOfGoal.success,
  hasError: (state: any) => state.updateNotesOfGoal.error,
};

export const request = (state: any, { id, notes }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    id: id,
    notes: notes,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { goal } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    goal: goal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_NOTES_OF_GOAL_REQUEST]: request,
  [Types.UPDATE_NOTES_OF_GOAL_SUCCESS]: success,
  [Types.UPDATE_NOTES_OF_GOAL_FAILURE]: failure,
});
